export const AUDIO_PLAYBACK_UNLOCKED_EVENT = "lesson-launchpad:audio-playback-unlocked";
export const AUDIO_PLAYBACK_UNLOCK_RETRY_WINDOW_MS = 1000;
